module.exports = __webpack_public_path__ + "vn.cc07a154881da36c00f2.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/vn.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/vn.svg
// module chunks = styles